import { HttpClient } from "@angular/common/http";
import { DataService } from "./data.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ReportViewer } from "../model/report-viewer";
import { DownloadLocalFileService } from "./download-local-file.service";

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private readonly endPoint: string = "/report";

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private downloadLocalFileService: DownloadLocalFileService
  ) {}

  async downloadExcel(
    items: any[],
    properties: string[],
    columns: string[]
  ): Promise<any> {
    const file = await this.dataService
      .post<string>(`${this.endPoint}/ExportExcel`, {
        items,
        properties,
        columns,
      })
      .toPromise();

     this.downloadLocalFileService.downLoadFile(file, 'Export', 'xlsx');
  }
}
